const SUBLIST_ACTIVE_CLASS = 'sublist--is-active';

const NAV_ITEM_HOOK = '[js-hook-main-nav-sublist-toggle]';
const NAV_SUBLIST_HOOK = '[js-hook-nav-sublist]';

class MainNav {
    constructor(element) {
        this.element = element;
        this.navItems = [...this.element.querySelectorAll(NAV_ITEM_HOOK)];
        this.navSublists = [...this.element.querySelectorAll(NAV_SUBLIST_HOOK)];

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.navItems.forEach(item => {
            item.addEventListener('click', e => {
                if (window.outerWidth < 1250) {
                    this.toggleSubList(e);
                }
            });
        });
    }

    //toggle sublist open/close for on click for smaller screens
    toggleSubList(e) {
        e.currentTarget.classList.toggle(SUBLIST_ACTIVE_CLASS);
        e.currentTarget.nextElementSibling.classList.toggle(SUBLIST_ACTIVE_CLASS);
    }
}

export default MainNav;
